import type { InspectionTemplate } from 'modules/inspections/types';
import type { FetchApi } from '../client';

export type AssetInfos = {
  id: number;
  publicId?: string;
  name: string;
};

export type PublicInspection = {
  inspectionRef?: string;
  questionnaireId?: number;
  questionnaireVersion?: number;
  assetInOrganizationId?: number;
  formData?: Record<string, unknown>;
  status: string;
  guestUserName?: string;
  createdAt: string;
  updatedAt: string | null;
  completedAt: string | null;
  questionnaire: InspectionTemplate;
};

export type PublicQuestionnaire = {
  uuid: string;
  title: string;
  description?: string | null;
};

export const publicApi = (fetchApi: FetchApi) => ({
  getAssetByPublicId(publicId: string): Promise<AssetInfos> {
    return fetchApi.get(`/public/asset/${publicId}`, { cache: false });
  },

  listQuestionnaires(publicAssetId: string): Promise<PublicQuestionnaire[]> {
    return fetchApi.get(
      `/public/inspections/questionnaires?publicAssetId=${encodeURIComponent(publicAssetId)}`,
      { cache: false },
    );
  },

  createInspection(
    payload: CreatePublicInspectionPayload,
  ): Promise<PublicInspection & { inspectionRef: string }> {
    return fetchApi.post('/public/inspections', payload);
  },

  getQuestionnaireByUuid(
    templateUuid: string,
    publicAssetId: string,
  ): Promise<InspectionTemplate> {
    return fetchApi.get(
      `/public/inspections/questionnaires/${encodeURIComponent(templateUuid)}?publicAssetId=${encodeURIComponent(publicAssetId)}`,
      { cache: false },
    );
  },

  getInspectionByRef(uuid: string): Promise<PublicInspection> {
    return fetchApi.get(`/public/inspections/${uuid}`, { cache: false });
  },

  updateInspection(
    uuid: string,
    payload: UpdatePublicInspectionPayload,
  ): Promise<PublicInspection> {
    return fetchApi.patch(`/public/inspections/${uuid}`, payload);
  },
});

export type CreatePublicInspectionPayload = {
  /** Generated by the client: a public inspection is addressed by this reference, not by its id. */
  inspectionRef: string;
  questionnaireUuid: string;
  publicAssetId: string;
  formData: Record<string, unknown>;
  status: 'pending';
  guestUserName: string;
};

export type UpdatePublicInspectionPayload = {
  formData?: Record<string, unknown>;
  status?: 'pending' | 'in_progress' | 'completed' | 'cancelled';
  guestUserName?: string;
};
